import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  paths: { name: string; path?: string }[];
}

const Breadcrumbs: React.FC<BreadcrumbProps> = ({ paths }) => {
  const { t } = useTranslation('sdRecordViewer');
  const basePath = '/sd_record_viewer/camera_list/';

  if (paths.length === 0) {
    return (
      <nav>
        <ul className="breadcrumb">
          <li>
            <span>{t('root')}&nbsp;</span>
          </li>
        </ul>
      </nav>
    );
  }

  return (
    <nav>
      <ul className="breadcrumb">
        <li>
          <Link to={basePath}>{t('root')}&nbsp;</Link>
        </li>
        {paths.map((path, index) => (
          <li key={index}>
            <span>/&nbsp;</span>
            {index === paths.length - 1 ? (
              <span>{path.name}</span>
            ) : (
              <Link to={basePath + path.path}>{path.name}&nbsp;</Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
